import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-audit">
      <h1 className="font-serif text-3xl text-navy mb-1">Audit Log</h1>
      <p className="text-slate-500 text-sm mb-6">A record of important system and admin actions.</p>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px] text-sm">
            <thead className="bg-slate-50 text-slate-500 text-left">
              <tr>
                <th className="py-3 px-4 font-medium">Action</th>
                <th className="py-3 px-4 font-medium">Entity</th>
                <th className="py-3 px-4 font-medium">Actor</th>
                <th className="py-3 px-4 font-medium">When</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l, i) => (
                <tr key={i} className="border-t border-slate-100">
                  <td className="py-2.5 px-4 text-slate-900">{l.action.replace(/_/g, " ")}</td>
                  <td className="py-2.5 px-4 font-mono text-xs text-slate-500">{l.entity_id}</td>
                  <td className="py-2.5 px-4 text-slate-600">{l.actor}</td>
                  <td className="py-2.5 px-4 text-xs text-slate-400">{new Date(l.at).toLocaleString()}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={4} className="py-10 text-center text-slate-400">No log entries yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
